
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import Head from 'next/head';
import styled from '@emotion/styled';
import useTranslation from 'next-translate/useTranslation';
import { H1 } from 'library/atoms/Typography';
import ContentLayout from 'library/atoms/ContentLayout';
import PageLayout from 'library/pages/PageLayout';
import { useRouter } from 'next/router';
const Page404 = () => {
    const { asPath } = useRouter();
    const { t } = useTranslation('404');
    const pageTitle = t('page-not-found');
    useEffect(() => {
        Sentry.captureMessage(`404 from ${asPath}`);
    }, [asPath]);
    return (<PageLayout layout="full" header={{
            pageTitle
        }}>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <ContentLayout>
        <main>
          <StyledPageWrapper>
            <H1>{pageTitle}</H1>
          </StyledPageWrapper>
        </main>
      </ContentLayout>
    </PageLayout>);
};
export default Page404;
const StyledPageWrapper = styled.div(() => ({
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
}));

    async function __Next_Translate__getStaticProps__1973fb7b89f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1973fb7b89f__ as getStaticProps }
  